module.exports = __webpack_public_path__ + "static/media/objective1.c4b20e3e.svg";